import { Button } from 'iglooform';
import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import useMobile from '@/hooks/useMobile';

import CheckedIcon from '@/assets/img/blue_checked_icon.svg';
import './index.less';
interface PSteps {
  // 所有的steps
  steps: {
    title: string;
    content: any;
    key: string;
  }[];
  // 设置展示step
  setActiveStep: any;
  // 当前展示的step的key
  activeStep: string;
}

const Steps = (props: PSteps) => {
  const isMobile = useMobile();

  const { formatMessage } = useIntl();
  const { steps, activeStep, setActiveStep } = props;

  // 当前最大的高亮tabIndex
  const [maxHighlightStep, setMaxHighlightStep] = useState(0);
  // 当前正在展示的<Compoennt />
  const [currentShowingContent, setCurrentShowingContent] = useState(null);
  // 当前正在展示的Component的Index
  const [currentShowingIndex, setCurrentShowingIndex] = useState(0);

  const onBackToStep = ({ index, key }: { index: number; key: string }) => {
    if (index > maxHighlightStep || index === currentShowingIndex) return;
    setActiveStep(key);
  };

  // 仅在PC端，设置maxHighlightStep
  // 规则是判断当前的activeIndex，如果它大于了maxHegihtStep，则maxHeightStep会被赋值
  useEffect(() => {
    const activeIndex = steps.reduce((res, cur, index) => {
      if (cur.key === activeStep) {
        return index;
      }
      return res;
    }, maxHighlightStep);

    if (activeIndex > maxHighlightStep && !isMobile) {
      setMaxHighlightStep(activeIndex);
    }

    setCurrentShowingIndex(activeIndex);
  }, [activeStep, maxHighlightStep, isMobile]);

  // 设置当前的currentShowingContent
  // 规则是判断当前的props.activeStep与props.steps遍历，取key相同的那个component
  useEffect(() => {
    const activeContent = steps.reduce((res, cur, index) => {
      if (cur.key === activeStep) {
        return cur.content;
      }
      return res;
    }, currentShowingContent);

    setCurrentShowingContent(activeContent);
  }, [activeStep, currentShowingContent]);

  const renderTitlePc = ({
    title,
    index,
  }: {
    title: string;
    index: number;
  }) => (
    <>
      <span className="stepTitleTitle">{title}</span>
      {maxHighlightStep > index && (
        <img className={'icon-checked'} src={CheckedIcon} />
      )}
    </>
  );

  const renderTitleMobile = ({
    title,
    index,
    onBackfunc,
  }: {
    title: string;
    index: number;
    onBackfunc: () => any;
  }) => (
    <>
      <div className="stepTitleNumAndTitle">
        <span className="stepTitleNum">
          {(index + 1).toString().padStart(2, '0')}
        </span>
        <span className="stepTitleTitle">{title}</span>
      </div>
      {index < currentShowingIndex ? (
        <Button type="link" onClick={onBackfunc}>
          {formatMessage({ id: 'Edit' })}
        </Button>
      ) : (
        <div className="stepTitleStepDesc">
          {formatMessage(
            {
              id: '{currentStep} of {allSteps}',
            },
            {
              currentStep: index + 1,
              allSteps: steps.length,
            },
          )}
        </div>
      )}
    </>
  );

  return (
    <div
      className={classnames('stepContainer', {
        'is-mobile': isMobile,
      })}
    >
      <Row className={'stepTitleContainer'}>
        {steps.map((step, index) => {
          const { title, key } = step;
          const isActive = maxHighlightStep >= index;
          return (
            <Col
              span={isMobile ? 24 : 24 / steps.length}
              key={key}
              className={classnames('stepTitle', {
                activeTitle: isActive,
              })}
              onClick={() => {
                if (isMobile) return;
                onBackToStep({ index, key });
              }}
            >
              <div className={'titleBox'}>
                {!isMobile && renderTitlePc({ title, index })}
                {isMobile &&
                  renderTitleMobile({
                    title,
                    index,
                    onBackfunc: () => onBackToStep({ index, key }),
                  })}
              </div>
              {isMobile && currentShowingIndex === index && (
                <div className={'contentBox'}>{currentShowingContent}</div>
              )}
            </Col>
          );
        })}
      </Row>

      {!isMobile && <div className={'contentBox'}>{currentShowingContent}</div>}
    </div>
  );
};

export default Steps;
